export const props = { viewBox: "0 0 16 16" };
export const innerHTML = `
    <svg width="14" height="14" fill="none">
        <circle cx="8" cy="8" r="4" fill="#137cdd"/>
    </svg>
`;
